import { connect } from 'react-redux';
import I18n from '../../lib/i18n';
import LanguageSelector from './LanguageSelector';

function mapStateToProps(state) {
  return {
    locale: state.localization.locale,
    availableLocales: I18n.getLocales(true),
  };
}

export default connect(mapStateToProps)(LanguageSelector);
